import SubscriptionsInfo from './SubscriptionsInfo'
export default SubscriptionsInfo
